@if (!accountIsEmpty && init) {
  <div class="pad-left-10 pad-right-10 pad-top-5" fxLayout="column">
    <account-horizontal-bar-chart [account]="accountModel" [chartId]="getCanvasClass()" [overBudget]="overBudget"
      class="account-chart">
    </account-horizontal-bar-chart>
  </div>
}
@if (accountIsEmpty && init) {
  <div class="pad-top-10" fxLayoutAlign="center center">
    <div>No Transactions</div>
  </div>
}